import { IState } from 'shared/store';

/**
 * @todo Удалить селектор для RSки
 * @description Данный функционал появился в задаче CD-158957 будет удалён в задаче CD-159117
 */
export const selectIsBestPlaceAnalyticsEnabled = (state: IState) => state.featureToggle.isBestPlaceAnalyticsEnabled;
